import { c as _c } from "react/compiler-runtime";
import { cn } from '@/frontend/utils';
type SplitViewEditorProps = {
  editorReady: boolean;
  previewReady: boolean;
  EditorSection: React.ReactNode;
  PreviewSection: React.ReactNode;
  height?: number;
  children?: React.ReactNode;
};
export const SplitViewEditor = t0 => {
  const $ = _c(16);
  const {
    editorReady,
    previewReady,
    EditorSection,
    PreviewSection,
    height,
    children
  } = t0;
  const t1 = editorReady && previewReady ? "flex w-full flex-col gap-2" : "hidden";
  let t2;
  if ($[0] !== t1) {
    t2 = cn(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${height}rem`;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      height: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== EditorSection) {
    t5 = <div className="bg-backgroundSecondary border-borderPrimary h-full flex-1 min-w-0 rounded-lg border">{EditorSection}</div>;
    $[4] = EditorSection;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== PreviewSection) {
    t6 = <div className="bg-backgroundSecondary border-borderPrimary h-full flex-1 min-w-0 rounded-lg border">{PreviewSection}</div>;
    $[6] = PreviewSection;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <div className="flex gap-2" style={t4}>{t5}{t6}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== children || $[13] !== t2 || $[14] !== t7) {
    t8 = <div className={t2}>{t7}{children}</div>;
    $[12] = children;
    $[13] = t2;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};